/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, August 2022
 * @format
 * @flow
 */

import { ActionTypes } from '../constants';

function updateFbCheckFilters(payload: Object) {
  return {
    type: ActionTypes.UPDATE_FB_CHECK_FILTERS,
    payload,
  };
};

export { updateFbCheckFilters };
